const initialStateGender = {
  gender: [],
  update_gender: false,
};

export default initialStateGender;